import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useReduxSearchState } from 'pages/search/hooks/use-redux-search-state';
import dayjs from 'utils/dayjs-timezone';
import TimeUtils from 'utils/time';
import { updateTimes } from 'store/search-request/search-request-actions';
import { END_TIME_ADJUSTMENT } from 'constants/time';
export const useHandlePastTimes = () => {
    const dispatch = useDispatch();
    const { parkingType, timezone, startsDate, endsDate } = useReduxSearchState();
    useEffect(() => {
        const now = dayjs().tz(timezone).set('second', 0).set('millisecond', 0);
        const minDateTime = now.get('minute') < 30
            ? now.set('minute', 0)
            : now.set('minute', 30);
        // Parse the dates directly in the target timezone
        const starts = startsDate ? dayjs.tz(startsDate, timezone) : undefined;
        const ends = endsDate ? dayjs.tz(endsDate, timezone) : undefined;
        // Both minDateTime and starts/ends are now in the same timezone for comparison
        const isStartInPast = starts?.isBefore(minDateTime) || false;
        const isEndInPast = ends?.isBefore(minDateTime) || false;
        if (isStartInPast || isEndInPast) {
            const newStarts = minDateTime.format(TimeUtils.V1_API_TIMESTAMP_FORMAT);
            const newEnds = isEndInPast
                ? minDateTime
                    .add(...END_TIME_ADJUSTMENT)
                    .format(TimeUtils.V1_API_TIMESTAMP_FORMAT)
                : ends?.format(TimeUtils.V1_API_TIMESTAMP_FORMAT);
            dispatch(updateTimes({
                starts: newStarts,
                ends: newEnds,
                isMonthly: parkingType === 'monthly',
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
